export default "__VITE_PUBLIC_ASSET__ef799049__"